class OriginStory {
  constructor() {
    this.section = document.querySelector('#origin-story');
    this.intro = document.querySelector('.origin-story-intro');
    this.title = document.querySelector('.origin-story-title');
    this.content = document.querySelector('.origin-story-content');
    this.btn = document.querySelector('.origin-story-btn');
    if(this.section) {
      this.events();
    }
  }

  events() {
    this.btn.addEventListener('click', this.startAnimation.bind(this));
  }

  // methods
  startAnimation() {
    this.hideButton();
    setTimeout(() => {
      this.showTitle();
    }, 1000);
    setTimeout(() => {
      this.showContent();
    }, 3200);
  }

  hideButton() {
    this.btn.classList.add('fade-out');
    this.intro.lastElementChild.classList.add('fade-out');
  }

  showTitle() {
    // remove button
    this.btn.classList.add('hidden');
    this.intro.lastElementChild.classList.add('hidden');

    // start animation
    this.title.classList.remove('hidden');
    this.title.classList.add('fade-in');
    setTimeout(() => {
      if(window.innerWidth > 1100) {
        this.intro.classList.add('shift-left');
      } else if(window.innerWidth > 640) {
        this.intro.classList.add('shift-up');
      } else {
        this.intro.classList.add('shift-up-mobile');
      }
    }, 1000);
  }

  showContent() {
    this.intro.classList.remove('block-middle');
    this.intro.classList.remove('flex');
    this.content.classList.remove('hidden');
    this.content.classList.add('flip');
    this.content.classList.add('fade-in');
  }
}

export default OriginStory;
